import React, { useEffect, useState } from "react";
import { useModalState } from "./ModalStateProvider";
import { triggerTopGoAwayButton } from "../Input/GoAwayButton";

interface ModalProps {
	children: React.ReactNode;
	className?: string;
}

const Modal: React.FC<ModalProps> = ({
	children,
	className = "bg-primary-background"
}) => {
	const modalRef = React.useRef<HTMLDivElement>(null);
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const [isAnimating, setIsAnimating] = useState<boolean>(false);
	const { modalVisible } = useModalState();

	useEffect(() => {
		if (modalVisible) {
			setIsVisible(true);
			// Small delay to ensure visibility before animation starts
			setTimeout(() => setIsAnimating(true), 100);
		} else {
			setIsAnimating(false);
			// Delay hiding until animation completes
			setTimeout(() => setIsVisible(false), 300);
		}
	}, [modalVisible]);

	// Handle outside clicks (scrim clicks)
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			//console.log(`Modal.onClickOutside called (${modalVisible})`)
			if (
				modalRef.current &&
				!modalRef.current.contains(event.target as Node)
			) {
				//console.log(`Modal.onClickOutside detected outsideclick (${modalVisible})`)
				// Use LIFO stack to trigger the topmost GoAwayButton
				triggerTopGoAwayButton();
			}
		};

		if (modalVisible) {
			//console.log(`Modal.onModalVisibleChange(${modalVisible}) register Listener`)
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			//console.log(`Modal.onModalVisibleChange(${modalVisible}) unRegister Listener`)
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [modalVisible]);

	const mobileClass = "w-full h-full m-0";
	const tabletClass = "w-full max-w-md max-h-[90vh] m-2 rounded-xl shadow-xl ";
	return (
		<div className={`${isVisible ? "" : "hidden"}`}>
			{/* Scrim/Overlay */}
			<div
				className={`fixed inset-0 bg-primary-scrim z-modal transition-opacity duration-300 ${isAnimating ? "opacity-70" : "opacity-0"}`}
			/>

			{/* Modal Container */}
			<div className="fixed inset-0 z-modal flex items-center justify-center">
				{/* Modal */}
				<div
					ref={modalRef}
					className={`${className} flex-1 flex-col items-center justify-center overflow-y-auto transition-opacity duration-300 ease-in-out ${isAnimating ? "opacity-100" : "opacity-0"} ${window.innerWidth >= 500 ? tabletClass : mobileClass}`}
				>
					{/* Content */}
					{children}
				</div>
			</div>
		</div>
	);
};

export default Modal;
